import React from 'react';
import { Popup } from 'semantic-ui-react';
import DatasetSubscribeButton from './DatasetSubscribeButton';
import DatasetSubscribeCard from './DatasetSubscribeCard';
import Selectors from '../hooks/selectors';

const DatasetSubscribeAction = ({ category, code }) => {
  const { disabled, subscribed, theme } = Selectors.useDatasetSubscribeAction({ category, code });

  return (
    <Popup
      on="click"
      className={`aridhia-theme-${theme}`}
      trigger={<div className="dib"><DatasetSubscribeButton disabled={disabled} subscribed={subscribed} /></div>}
    >
      <DatasetSubscribeCard code={code} disabled={disabled} subscribed={subscribed} />
    </Popup>
  );
};

export default DatasetSubscribeAction;
